import React from "react";
import { Button } from "@heroui/react";

type ButtonProps = React.ComponentProps<typeof Button>;

/****
 * RedButton component that renders a button with red background and white text.
 *
 * @param {string} className - Additional CSS classes to apply to the button.
 * @param {ButtonProps} props - Other props to pass through to the Button component.
 * @returns {JSX.Element} The rendered Button component with red styling.
 */
const RedButton: React.FC<ButtonProps> = ({ className = "", ...props }) => {
  const combined = `${className ? `${className} ` : ""}text-[#ffffff] bg-[#a12121]`;
  return <Button radius="none" {...props} className={combined} />;
};

export default RedButton;
